__webpack_require__.p = "https://prof.byonde.asia/";